import { render, staticRenderFns } from "./Cooperators.vue?vue&type=template&id=50df6067&"
import script from "./Cooperators.vue?vue&type=script&lang=js&"
export * from "./Cooperators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports